import React from 'react';
import { motion } from 'framer-motion';
type PatternListProps = {
  items: string[];
};
export function PatternList({
  items
}: PatternListProps) {
  return <ul className="my-6 grid gap-px border border-ink/20 bg-ink/20 sm:grid-cols-2" data-id="element-65" data-mp="25i0hxg8beew5">
      {items.map((item, i) => <motion.li key={item} initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.35,
      delay: i * 0.06
    }} className="flex items-baseline gap-3 bg-paper px-4 py-3" data-id="element-66" data-mp="2fiav50ucnmbb" data-mpi={i}>
          <span className="font-serif text-sm font-bold text-accent" data-id="element-67" data-mp="2ocywifwt0juu">
            {String(i + 1).padStart(2, '0')}
          </span>
          <span className="font-sans text-[15px] font-medium" data-id="element-68" data-mp="2y88xr1fdon7k">{item}</span>
        </motion.li>)}
    </ul>;
}